<template>
  <fragment>
    <div class="flex-column margin-bottom-4">
      <div class="invite-input-label-container">
        <span class="invite-input-label-txt">Country</span>
      </div>
      <SACDropdown
        :options="countries"
        :value="serviceAddress.country"
        optionLabel="country"
        optionValue="code"
        placeholder="Select Country"
        field="country"
        :change="(field, value) => changeAddress('serviceAddress', field, value)"
        :error="errorObj.sCountryErr"
      />
    </div>
    <div class="flex-column margin-bottom-4">
      <div class="invite-input-label-container">
        <span class="invite-input-label-txt">Service Address Line 1</span>
      </div>
      <SACInput
        id="service-address"
        placeholder="Enter address 1"
        field="address1"
        :value="serviceAddress.address1"
        :change="(field, value) => changeAddress('serviceAddress', field, value)"
        :error="errorObj.sAddress1Err"
      />
    </div>
    <div class="flex-column margin-bottom-4">
      <div class="invite-input-label-container">
        <span class="invite-input-label-txt">Service Address Line 2 (optional)</span>
      </div>
      <SACInput
        placeholder="Enter apt #, suite #, etc"
        field="address2"
        :value="serviceAddress.address2"
        :change="(field, value) => changeAddress('serviceAddress', field, value)"
      />
    </div>
    <div class="flex-row justify-between align-center margin-bottom-4">
      <div class="flex-column flex-1 margin-right-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">City</span>
        </div>
        <SACInput
          placeholder="Enter city"
          field="city"
          :value="serviceAddress.city"
          :change="(field, value) => changeAddress('serviceAddress', field, value)"
          :error="errorObj.sCityErr"
        />
      </div>
      <div class="flex-column flex-1 margin-right-4">
        <div class="invite-input-label-container">
          <span
            v-if="serviceAddress.country === 'CA'"
            class="invite-input-label-txt"
          >
            Province
          </span>
          <span
            v-else
            class="invite-input-label-txt"
          >
            State
          </span>
        </div>
        <SACDropdown
          :options="stateOptions(serviceAddress.country)"
          :value="serviceAddress.state"
          :placeholder="serviceAddress.country === 'CA' ? 'Select Province' : 'Select State'"
          field="state"
          :change="(field, value) => changeAddress('serviceAddress', field, value)"
          :error="errorObj.sStateErr"
        />
      </div>
      <div class="flex-column flex-1">
        <div class="invite-input-label-container">
          <span
            v-if="serviceAddress.country === 'CA'"
            class="invite-input-label-txt"
          >
            Postal Code
          </span>
          <span
            v-else
            class="invite-input-label-txt"
          >
            Zip
          </span>
        </div>
        <SACInput
          :placeholder="serviceAddress.country === 'CA' ? 'Enter postal code' : 'Enter zip code'"
          field="zip"
          :value="serviceAddress.zip"
          :change="(field, value) => changeAddress('serviceAddress', field, value)"
          :error="errorObj.sZipErr"
        />
      </div>
    </div>
    <div class="margin-bottom-4">
      <SACCheckbox
        label="Billing address same as Service address"
        :checked="sameAsBilling"
        field="sameAsBilling"
        :change="(field) => change(field, !sameAsBilling)"
        :disable="disableCheckbox"
      />
    </div>
    <div v-if="!sameAsBilling">
      <div class="flex-column margin-bottom-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Country</span>
        </div>
        <SACDropdown
          :options="countries"
          :value="billingAddress.country"
          optionLabel="country"
          optionValue="code"
          placeholder="Select Country"
          field="country"
          :change="(field, value) => changeAddress('billingAddress', field, value)"
          :error="errorObj.countryErr"
        />
      </div>
      <div class="flex-column margin-bottom-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Billing Address Line 1</span>
        </div>
        <SACInput
          placeholder="Enter address 1"
          field="address1"
          :value="billingAddress.address1"
          :change="(field, value) => changeAddress('billingAddress', field, value)"
          :error="errorObj.address1Err"
        />
      </div>
      <div class="flex-column margin-bottom-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Billing Address Line 2 (optional)</span>
        </div>
        <SACInput
          placeholder="Enter apt #, suite #, etc"
          field="address2"
          :value="billingAddress.address2"
          :change="(field, value) => changeAddress('billingAddress', field, value)"
        />
      </div>
      <div class="flex-row justify-between align-center margin-bottom-4">
        <div class="flex-column flex-1 margin-right-4">
          <div class="invite-input-label-container">
            <span class="invite-input-label-txt">City</span>
          </div>
          <SACInput
            placeholder="Enter city"
            field="city"
            :value="billingAddress.city"
            :change="(field, value) => changeAddress('billingAddress', field, value)"
            :error="errorObj.cityErr"
          />
        </div>
        <div class="flex-column flex-1 margin-right-4">
          <div class="invite-input-label-container">
            <span
              v-if="billingAddress.country === 'CA'"
              class="invite-input-label-txt"
            >
              Province
            </span>
            <span
              v-else
              class="invite-input-label-txt"
            >
              State
            </span>
          </div>
          <SACDropdown
            :options="stateOptions(billingAddress.country)"
            :value="billingAddress.state"
            :placeholder="billingAddress.country === 'CA' ? 'Select Province' : 'Select State'"
            field="state"
            :change="(field, value) => changeAddress('billingAddress', field, value)"
            :error="errorObj.stateErr"
            searchParameter="label"
          />
        </div>
        <div class="flex-column flex-1">
          <div class="invite-input-label-container">
            <span
              v-if="billingAddress.country === 'CA'"
              class="invite-input-label-txt"
            >
              Postal Code
            </span>
            <span
              v-else
              class="invite-input-label-txt"
            >
              Zip
            </span>
          </div>
          <SACInput
            :placeholder="billingAddress.country === 'CA' ? 'Enter postal code' : 'Enter zip code'"
            field="zip"
            :value="billingAddress.zip"
            :change="(field, value) => changeAddress('billingAddress', field, value)"
            :error="errorObj.zipErr"
          />
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapState } from 'vuex';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';

export default {
  name: 'AddressInfo',
  components: {
    SACInput,
    SACCheckbox,
    SACDropdown,
  },
  props: {
    billingAddress: Object,
    serviceAddress: Object,
    sameAsBilling: Boolean,
    change: Function,
    changeAddress: Function,
    errorObj: Object,
  },
  computed: {
    ...mapState({
      states: (state) => state.general.states,
      countries: (state) => state.general.countries,
    }),
    disableCheckbox() {
      const {
        address1,
        city,
        state,
        zip,
        country,
      } = this.serviceAddress;
      return !address1 || !city || !state || !zip || !country;
    },
  },
  methods: {
    stateOptions(country) {
      const {
        states,
      } = this;
      let stateOptions = states;
      if (country) {
        stateOptions = states.filter((st) => {
          if (country) {
            return st.countryCode === country;
          }
          return true;
        });
      }
      return stateOptions.map((s) => ({
        label: s.state,
        value: s.abbreviation,
      }));
    },
  },
};
</script>
